<script lang="ts">
    import Divider from "@components/Divider.svelte";
    import T from "@components/T.svelte";
    import ViewMore from "@components/ViewMore.svelte";

    export let reply: string;
    export let namespace: string;
</script>

<div class="gw-rv-item-reply">
    <Divider />

    <div class="gw-rv-item-reply__content">
        <span class="gw-rv-item-reply__shopName">
            <T {namespace} translationKey="shop_reply" />
        </span>
        <ViewMore
            text={reply}
            class="gw-rv-item-reply__reply"
            gradientColor="#f9fafb"
        >
            <svelte:fragment slot="view_more_text">
                <T {namespace} translationKey="view_more" />
            </svelte:fragment>
            <svelte:fragment slot="view_less_text">
                <T {namespace} translationKey="view_less" />
            </svelte:fragment>
        </ViewMore>
    </div>
</div>

<style lang="postcss">
    .gw-rv-item-reply {
        display: flex;
        flex-direction: column;
        gap: 0.75em;
        margin-top: 0.25em;

        &__content {
            padding: 1em;
            border-left: 2px solid var(--gw-rv-theme-primaryColor, #8a96a1);
            background-color: var(--gw-rv-review-reply-bg, #fafafa);
            border-radius: 0.25em;
        }

        &__shopName {
            font-size: 0.75em;
            text-transform: uppercase;
        }

        :global(&__reply) {
            width: fit-content;
            word-break: break-all;
            margin: 8px 0 0;
            font-size: 0.875em;
        }
    }
</style>
